import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationEditorComponent } from './translation-editor.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [TranslationEditorComponent],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [TranslationEditorComponent],
})
export class TranslationEditorModule {}
